import DOMPurify from 'dompurify'

// rel="noopener noreferrer" on target="_blank" links (reverse tabnabbing),
// merged into any existing rel so policies like nofollow/ugc aren't dropped.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        const tokens = (node.getAttribute('rel') || '').split(/\s+/).filter(Boolean)
        ;['noopener', 'noreferrer'].forEach(t => { if (!tokens.includes(t)) { tokens.push(t) } })
        node.setAttribute('rel', tokens.join(' '))
    }
})

// Keep iframe embed attributes, scoped to <iframe> only (not a global ADD_ATTR).
// src is excluded so it stays under DOMPurify's URI policy (blocks javascript:/data:).
const IFRAME_ATTRS = new Set(['allow', 'allowfullscreen', 'frameborder', 'width', 'height', 'title', 'loading', 'referrerpolicy'])
DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
    if (node.tagName === 'IFRAME' && IFRAME_ATTRS.has(data.attrName)) {
        data.forceKeepAttr = true
    }
})

// Allow <iframe> embeds (host-agnostic, like before); forbid the XSS-bearing srcdoc.
const SANITIZE_OPTIONS = {
    ADD_TAGS: ['iframe'],
    FORBID_ATTR: ['srcdoc'],
}

// Central sanitizer for all user-/admin-authored HTML. Keeps formatting + links,
// strips <script>, on* handlers and javascript:/data: URIs.
export function sanitizeHtml(html) {
    return DOMPurify.sanitize(html == null ? '' : String(html), SANITIZE_OPTIONS)
}

// Drop-in replacement for v-html that sanitizes before injecting.
const SafeHtml = {
    inserted(el, binding) {
        el.innerHTML = sanitizeHtml(binding.value)
    },
    update(el, binding) {
        if (binding.value !== binding.oldValue) {
            el.innerHTML = sanitizeHtml(binding.value)
        }
    }
}

export default {
    install(Vue) {
        Vue.directive('safe-html', SafeHtml)
    }
}

export { SafeHtml }
